import React from 'react'

// icons
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faMoneyBill } from '@fortawesome/free-solid-svg-icons'

// routes
import { withRouter } from 'react-router-dom'

// modals
import ModalDetalleCompra from './ModalDetalleCompra/ModalDetalleCompra'
import ModalDetallePago from './ModalDetallePagos/ModalDetallePago'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// services
import { deleteByIdCompra } from '../../Services/compraService'

// utils
import {
    formatFechaArgentina,
    formatFechaNegocio,
} from '../../utils/fechaArgentina'

// Sweet alert
import Swal from 'sweetalert2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ItemCompras = ({ compra, setIsLoad }) => {
    const estado = (estado) => {
        if (estado === 'ADEUDADA')
            return <p className="text-primary">ADEUDADA</p>
        if (estado === 'PAGADA_PARCIALMENTE')
            return <p className="text-warning">PAGADA PARCIALMENTE</p>
        if (estado === 'PAGADA') return <p className="text-success">PAGADA</p>
    }

    const EliminarCompraSubmit = (compra) => {
        let text = 'Se descontará el stock de los artículos de esta compra.'
        if (compra.estado === 'ADEUDADA') {
            text +=
                ' También se restará $' +
                compra.total.toFixed(2) +
                ' de la deuda (debo) del proveedor.'
        }
        Swal.fire({
            title: 'Estas seguro de eliminar?',
            text,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Eliminar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                deleteByIdCompra(compra.id)
                    .then((res) => {
                        Swal.fire(
                            'Eliminado!',
                            'La compra fue eliminada.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text:
                                (error.response &&
                                    error.response.data &&
                                    error.response.data.message) ||
                                'Hubo un error vuelve a intentar!',
                        })
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{compra.id}</th>
            <td>{compra.proveedor.nombre}</td>
            <td>${compra.total.toFixed(2)}</td>
            <td>{estado(compra.estado)}</td>
            <td>{formatFechaNegocio(compra.fecha)}</td>
            <td>{formatFechaArgentina(compra.createdAt)}</td>
            <td>{compra.sucursal.nombre}</td>
            <td>{compra.tipoComprobante.nombre}</td>
            <td>{compra.numeroComprobante}</td>
            <td>
                <ModalDetallePago item={compra} />
                <ModalDetalleCompra item={compra} />
                <button
                    className="btn text-primary"
                    onClick={() => {
                        EliminarCompraSubmit(compra)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemCompras)
